import { appConfig } from 'config/customization';
import Device from 'constants/deviceSizes';
import { textInput } from 'constants/fonts';

export default {
  header: {
    display: 'flex',
    width: '50%',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    [Device.mobile]: {
      width: '100%'
    }
  },
  addButton: {
    color: appConfig.colors.primaryButton
  },
  textInputSize: {
    fontSize: textInput
  }
};
